export default __webpack_public_path__ + "static/media/gold-x-back.17fa97b9.svg";